export default "__VITE_ASSET__DTuCiWNH__";